<template>
  <div class="orders-container">
    <div class="filters-section">
      <h2>Sipariş Filtreleri</h2>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Sipariş No</label>
            <input type="text" class="form-control" v-model="filters.orderNumber" placeholder="Sipariş No">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Paket No</label>
            <input type="text" class="form-control" v-model="filters.packageNumber" placeholder="Paket No">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Kargo No</label>
            <input type="text" class="form-control" v-model="filters.shippingNumber" placeholder="Kargo No">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Platform</label>
            <select class="form-control" v-model="filters.platform">
              <option value="">Tümü</option>
              <option value="trendyol">Trendyol</option>
              <option value="hepsiburada">Hepsiburada</option>
              <option value="n11">N11</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Başlangıç Tarihi</label>
            <input type="date" class="form-control" v-model="filters.startDate">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Bitiş Tarihi</label>
            <input type="date" class="form-control" v-model="filters.endDate">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group" style="margin-top: 32px;">
            <button class="btn btn-primary" @click="applyFilters">Filtrele</button>
            <button class="btn btn-secondary" @click="resetFilters">Filtreleri Temizle</button>
          </div>
        </div>
      </div>
    </div>

    <div class="orders-table mt-4">
      <h2>Siparişler</h2>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Sipariş No</th>
              <th>Paket No</th>
              <th>Kargo No</th>
              <th>Platform</th>
              <th>Sipariş Tarihi</th>
              <th>Durum</th>
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in filteredOrders" :key="order.id">
              <td>{{ order.orderNumber }}</td>
              <td>{{ order.packageNumber }}</td>
              <td>{{ order.shippingNumber }}</td>
              <td>{{ order.platform }}</td>
              <td>{{ formatDate(order.orderDate) }}</td>
              <td>
                <span :class="['badge', getStatusClass(order.status)]">
                  {{ order.status }}
                </span>
              </td>
              <td>
                <button class="btn btn-sm btn-info" @click="viewOrderDetails(order)">
                  Detay
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderManagement',
  data() {
    return {
      filters: {
        orderNumber: '',
        packageNumber: '',
        shippingNumber: '',
        platform: '',
        startDate: '',
        endDate: ''
      },
      orders: [
        // Örnek veri
        {
          id: 1,
          orderNumber: 'ORD-001',
          packageNumber: 'PKG-001',
          shippingNumber: 'CARGO-001',
          platform: 'trendyol',
          orderDate: '2024-05-01',
          status: 'Hazırlanıyor'
        },
        // Daha fazla sipariş verisi buraya eklenebilir
      ]
    }
  },
  computed: {
    filteredOrders() {
      return this.orders.filter(order => {
        return (
          (!this.filters.orderNumber || order.orderNumber.includes(this.filters.orderNumber)) &&
          (!this.filters.packageNumber || order.packageNumber.includes(this.filters.packageNumber)) &&
          (!this.filters.shippingNumber || order.shippingNumber.includes(this.filters.shippingNumber)) &&
          (!this.filters.platform || order.platform === this.filters.platform) &&
          (!this.filters.startDate || new Date(order.orderDate) >= new Date(this.filters.startDate)) &&
          (!this.filters.endDate || new Date(order.orderDate) <= new Date(this.filters.endDate))
        )
      })
    }
  },
  methods: {
    applyFilters() {
      // Filtreleme işlemi computed property üzerinden otomatik yapılıyor
    },
    resetFilters() {
      this.filters = {
        orderNumber: '',
        packageNumber: '',
        shippingNumber: '',
        platform: '',
        startDate: '',
        endDate: ''
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('tr-TR')
    },
    getStatusClass(status) {
      const statusClasses = {
        'Hazırlanıyor': 'bg-warning',
        'Kargoda': 'bg-info',
        'Teslim Edildi': 'bg-success',
        'İptal Edildi': 'bg-danger'
      }
      return statusClasses[status] || 'bg-secondary'
    },
    viewOrderDetails(order) {
      // Sipariş detaylarını görüntüleme işlemi
      console.log('Sipariş detayları:', order)
    }
  }
}
</script>

<style scoped>
.orders-container {
  padding: 20px;
}

.filters-section {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.orders-table {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.badge {
  padding: 5px 10px;
  border-radius: 3px;
}
</style> 